import { useEffect, useState } from "react";
import { getPopularStores } from "@/api/content";
import { getBrandConfig } from "@/config/brand";
import type { StoreCard } from "@/types/content";
import StoreCard from "@/components/base/StoreCard";
import SectionSkeleton from "@/components/base/SectionSkeleton";

export default function PopularStores() {
  const [stores, setStores] = useState<StoreCard[]>([]);
  const [loading, setLoading] = useState(true);
  const config = getBrandConfig().popularStores;
  const global = getBrandConfig().global;

  useEffect(() => {
    getPopularStores(3).then((data) => {
      setStores(data);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6 md:mb-8">
            <h2 className="section-title">
              <i className="ri-fire-line text-accent text-xl md:text-2xl w-6 h-6 flex items-center justify-center" />
              {config.title}
            </h2>
          </div>
          <SectionSkeleton type="cards" count={3} columns={3} surface="alt" aspectRatio="4/3" footerLines={3} />
        </div>
      </section>
    );
  }

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <h2 className="section-title">
            <i className="ri-fire-line text-accent text-xl md:text-2xl w-6 h-6 flex items-center justify-center" />
            {config.title}
          </h2>
          <a
            href="/stores"
            className="text-sm text-slate-500 hover:text-primary transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            {global.viewAll}
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {stores.map((store) => (
            <StoreCard
              key={store.id}
              store={store}
              surface="white"
              imageOverlay={
                <div className="absolute top-3 right-3 bg-yellow-50 px-2 py-1 rounded-lg flex items-center gap-1">
                  <i className="ri-star-fill text-yellow-400 text-xs" />
                  <span className="text-xs font-semibold text-yellow-700">{store.rating}</span>
                </div>
              }
              footer={
                <>
                  <p className="text-sm text-slate-500 line-clamp-2 leading-relaxed mb-3">
                    {store.description}
                  </p>
                  <div className="flex items-center gap-1.5 text-xs text-slate-400">
                    <i className="ri-map-pin-line" />
                    <span>{store.location}</span>
                    <span className="mx-1">·</span>
                    <span>{store.reviewCount} {global.reviews}</span>
                  </div>
                </>
              }
            />
          ))}
        </div>
      </div>
    </section>
  );
}